import { Theme } from "@material-ui/core/styles";
import { BaseCSSProperties, makeStyles } from "@material-ui/styles";
import { useAppState } from "../../../../common/appState";
import { appsPublicImg } from "../../../../common/consts";
import { spaceBetween } from "../../../../common/util/Array/spaceBetween";
import "./animation.css";

const shuriken = appsPublicImg + "shuriken.png";

interface Props {
    size?: string | number;
    style?: BaseCSSProperties;
    className?: string;
}
export default function ShurikenProgress({ size, style, className }: Props) {
    const [isDarkMode] = useAppState("isDarkMode");
    const c = useShurikenProgressStyles({ size, style, isDarkMode });
    return (
        <div className={spaceBetween("center", c.container, className)}>
            <img
                src={shuriken}
                alt="shuriken"
                className={spaceBetween("ShurikenProgress", c.img)}
            />
        </div>
    );
}
const useShurikenProgressStyles = makeStyles<
    Theme,
    {
        size?: string | number;
        style?: BaseCSSProperties;
        isDarkMode: boolean | null;
    }
>({
    container: ({ style }) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
    }),
    img: ({ size, isDarkMode }) => ({
        width: size,
        height: size,
        filter: isDarkMode
            ? `var(--ln-dark-mode-reverse) drop-shadow(0px 0px 5px rgb(0, 0, 0)) !important`
            : undefined,
    }),
});

export function FullScreenShurikenProgress({ style, size }: Props) {
    const c = useFullScreenShurikenProgressStyles({ style });
    return (
        <div className={c.container}>
            <ShurikenProgress size={size || "20%"} />
        </div>
    );
}
const useFullScreenShurikenProgressStyles = makeStyles<
    Theme,
    { style?: BaseCSSProperties }
>({
    container: ({ style }) => ({
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
    }),
});
